import React from 'react';
import { FeatureBadge } from 'new/elements/FeatureBadge';

export interface FeatureBadgeConfig {
  enabled: boolean;
  featureType: 'beta' | 'early-access' | 'experimental' | 'new';
}

export const FEATURE_BADGES: Record<string, FeatureBadgeConfig> = {
  // External Trigger feature badge (used across multiple components)
  EXTERNAL_TRIGGER: {
    enabled: false, // Disabled as requested
    featureType: 'beta',
  },
  FLOW_RUNS: {
    enabled: false, // Disabled as requested
    featureType: 'beta',
  },
};

/**
 * Helper function to check if a feature badge should be shown
 */
export const shouldShowFeatureBadge = (featureKey: string): boolean => {
  const config = FEATURE_BADGES[featureKey];
  return config?.enabled ?? false;
};

/**
 * Helper function to get feature badge configuration
 * Returns the config only if the feature is enabled
 */
export const getFeatureBadgeConfig = (featureKey: string): FeatureBadgeConfig | null => {
  const config = FEATURE_BADGES[featureKey];
  return config?.enabled ? config : null;
};

/**
 * Renders a feature badge if the feature is enabled
 * @param featureKey - The feature key to check
 * @param customProps - Custom props to pass to the FeatureBadge component
 * @returns JSX element or null
 */
export const renderFeatureBadge = (featureKey: string, customProps = {}) => {
  const badgeConfig = getFeatureBadgeConfig(featureKey);
  if (!badgeConfig) return null;

  return <FeatureBadge featureType={badgeConfig.featureType} {...customProps} />;
};
